export default __webpack_public_path__ + "static/media/iTAMES Logo.6ff5423f.png";